<mapfre-card [singleCard]="false" [additionalClasses]="" *ngIf="show">
  <div class="row align-middle align-items-center">
    <div class="col-sm-4 col-md-6 col-xl-4 col-12 mb-2">
      <div class="row">
    <div class="col-sm-12 col-md-6 col-6 text-center no-padding">
      <img src="./assets/img/images/leakbot_logo.png" alt="leakbot logo" />
    </div>
    <div class="col-sm-12 col-md-6 col-6 align-middle text-center no-padding">
      <img src="./assets/img/images/leakbot_device.png" alt="leakbot device" />
    </div>
  </div>
  </div>
    <div class="col-sm-8 col-md-6 col-xl-8 col-12">
      <div class="row ml-2">
    <div class="col-xl-7 col-12 grey-color">
      <h5 class="row font-bold">Exclusive Program!</h5>
      <div class="row">No one ever thinks about leaks until it is too late.</div>
      <div class="row font-bold mb-2 fs-16">Get a FREE Smart Leak Detecting Device!</div>
      <div class="row mb-3">
      <a id="leakbot-terms" class="grey-color fs-12" target="_blank" rel="noopener" href="https://insurance.mapfreusa.com/leakbot-terms-and-conditions/">Terms and Conditions</a>
    </div>
    </div>
    <div class="col-xl-5 col-12 align-self-end text-left no-padding">
      <mapfre-button
      [additionalClasses]="'ghost tertiary medium-btn'"
      (click)="openLeakbot()"
    >Sign up for free now!</mapfre-button>
    </div>
  </div>
  </div>
</div>
  <div class="clear-fix"></div>
</mapfre-card>